import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { HttpRequestService } from '../../services/HttpRequestService';
import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { UtilsService } from '../../services/UtilsService';
import Checkbox from '../../common/Checkbox';
import Report from '../../common/Report';

class ShippingCostReport extends Component {

    constructor(props) {
        super(props);
        this.utils = new UtilsService();
        var initialState = {
            accountTypes: [],
            accountTypeIds: "",
            beginDate: moment(new Date()).toDate(),
            endDate: moment(new Date()).toDate(),
            customerNumber: '',
            shipmentCategory: "",
            report: null,
        }
        this.sortBy = "";
        this.sortDirection = "";
        this.paramsKey = "params.shipping-cost-report";
        this.state = this.utils.prepareSessionState(initialState, this.paramsKey);

        this.http = new HttpRequestService();
        this.handleBeginDateChange = this.handleBeginDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleCustomerNumberChange = this.handleCustomerNumberChange.bind(this);
        this.handleAccountTypeChange = this.handleAccountTypeChange.bind(this);
        this.handleShipmentCategoryChange = this.handleShipmentCategoryChange.bind(this);
        this.hasAccountType = this.hasAccountType.bind(this);
        this.getAccountTypes = this.getAccountTypes.bind(this);
        this.getReport = this.getReport.bind(this);
        this.sortReport = this.sortReport.bind(this);
    }

    componentDidMount() {
        this.getAccountTypes();
    }

    handleBeginDateChange(e) {
        this.setState({ beginDate: e });
    }

    handleEndDateChange(e) {
        this.setState({ endDate: e });
    }

    handleCustomerNumberChange(e) {
        this.setState({ customerNumber: e.target.value });
    }

    handleShipmentCategoryChange(e) {
        this.setState({ shipmentCategory: e.target.value });
    }

    handleAccountTypeChange(checked, accountType) {
        var accountTypeIds = this.state.accountTypeIds;
        var arr = accountTypeIds !== "" ? accountTypeIds.split(",") : [];
        if (checked) {
            arr.push(accountType.key);
            this.setState({
                accountTypeIds: arr.length > 0 ? arr.join(",") : ""
            });
        }
        else {
            arr.splice(arr.findIndex(a => a === accountType.key), 1);
            this.setState({
                accountTypeIds: arr.length > 0 ? arr.join(",") : ""
            });
        }
    }

    hasAccountType(accountType) {
        var selectedAccountTypeIds = this.state.accountTypeIds.split(",");
        var result = selectedAccountTypeIds.find(a => a === accountType.key);
        return !!result;
    }

    getPrintPDFUrl(type, order) {
        return this.http.HOST + "/Print/Order?type=" + type + "&OrderID=" + order.orderID + "&OrderNumber=" + order.orderNumber;
    }

    getAccountTypes() {
        this.http.get("/api/Orders/GetAccountTypes", null).then(data => {
            data = data.filter(d => ["8", "11", "14"].indexOf(d.key) >= 0);
            if (this.state.accountTypeIds.length === 0) {
                var accountTypeIds = data.map(function (a) {
                    return a.key;
                });
                this.setState({
                    accountTypeIds: accountTypeIds.join(",")
                })
            }
            this.setState({ accountTypes: data });
        });
    }

    getReport(e) {
        if (!!e) {
            e.preventDefault();
        }
        var params = {
            beginDate: this.state.beginDate != null ? moment(this.state.beginDate).format('L') : "",
            endDate: this.state.endDate != null ? moment(this.state.endDate).format('L') : "",
            customerNumber: this.state.customerNumber,
            accountTypeIds: this.state.accountTypeIds,
            shipmentCategory: this.state.shipmentCategory,
            sortBy: this.sortBy,
            sortDirection: this.sortDirection
        }

        sessionStorage.setItem(this.paramsKey, JSON.stringify(params));

        this.http.get('/api/Report/GetShippingCostReport', params).then(data => {
            this.setState({ report: data });
        });
    }

    sortReport(field) {
        if (this.sortBy !== field) {
            this.sortDirection = "ASC";
        }
        else {
            if (this.sortDirection === "ASC") {
                this.sortDirection = "DESC";
            }
            else {
                this.sortDirection = "ASC";
            }
        }
        this.sortBy = field;
        this.getReport();
    }

    render() {
        return (
            <div className="page-inner">
                <div className="page-header">
                    <h4 className="page-title">Shipping Cost Report</h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={this.getReport}>
                                    <div className="form-row">
                                        <div className="form-group col-md-3">
                                            <label htmlFor="beginDate">Invoices From</label>
                                            <DatePicker className="form-control" selected={this.state.beginDate} onChange={this.handleBeginDateChange} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label htmlFor="endDate">Invoices To</label>
                                            <DatePicker className="form-control" selected={this.state.endDate} onChange={this.handleEndDateChange} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label>Customer # (optional)</label>
                                            <input type="text" className="form-control" value={this.state.customerNumber} onChange={this.handleCustomerNumberChange} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label>Shipment Category</label>
                                            <select className="form-control" value={this.state.shipmentCategory} onChange={this.handleShipmentCategoryChange}>
                                                <option value="">-- ALL --</option>
                                                <option value="Sample">Sample</option>
                                                <option value="Trade">Trade</option>
                                                <option value="Other">Other</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label>Account Types</label>
                                            <div>
                                                {this.state.accountTypes.map(accountType =>
                                                    <Checkbox style={{ display: "inline-block" }} key={accountType.key} label={accountType.value} checked={this.hasAccountType(accountType)} onChange={(checked) => this.handleAccountTypeChange(checked, accountType)}></Checkbox>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row justify-content-end">
                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {this.state.report != null &&
                            <Report name="ShippingCostReport" hasData={this.state.report.items && this.state.report.items.length > 0} title="Shipping Cost Report" description={this.state.report.description}>
                                <div className="form-row">
                                    <table className="table table-striped mt-1 report-table">
                                        <thead>
                                            <tr>
                                                <th className="sortable" scope="col" onClick={(e) => this.sortReport("OrderNumber")}>INV #</th>
                                                <th className="sortable" scope="col" onClick={(e) => this.sortReport("FulfillDate")}>INV DATE</th>
                                                <th className="sortable" scope="col" onClick={(e) => this.sortReport("CustomerNumber")}>CUST #</th>
                                                <th className="sortable" scope="col" onClick={(e) => this.sortReport("CompanyName")}>CUSTOMER</th>
                                                <th className="sortable" scope="col" onClick={(e) => this.sortReport("Service")}>SERVICE</th>
                                                <th className="sortable currency" scope="col" onClick={(e) => this.sortReport("TotalWeight")}>TOTAL WEIGHT</th>
                                                <th scope="col">BOX DIMENSIONS</th>
                                                <th className="sortable currency" scope="col" onClick={(e) => this.sortReport("CarrierFee")}>CARRIER FEE</th>
                                                <th className="sortable currency" scope="col" onClick={(e) => this.sortReport("ShippingCharge")}>SHIPPING CHARGE</th>
                                                <th className="sortable" scope="col" onClick={(e) => this.sortReport("ShipmentCategory")}>SHIPMENT CATEGORY</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.report.items.map((item, index) =>
                                                <tr key={index}>
                                                    <td><a href={this.getPrintPDFUrl("Invoice", item)} target="_blank" rel="noopener noreferrer">{item.orderNumber}</a></td>
                                                    <td>{moment(item.fulfillDate).format('l')}</td>
                                                    <td><Link to={"/customer/" + item.customerID}>{item.customerNumber}</Link></td>
                                                    <td>{item.companyName}</td>
                                                    <td>{item.service}</td>
                                                    <td className="currency">{item.totalWeight}</td>
                                                    <td style={{ whiteSpace: "pre-line" }}>{item.boxDimensions}</td>
                                                    <td className="currency">{this.utils.toCurrency(item.carrierFee, item.currencyCode)}</td>
                                                    <td className="currency">{this.utils.toCurrency(item.shippingCharge, item.currencyCode)}</td>
                                                    <td>{item.shipmentCategory}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </Report>
                        }
                    </div>
                </div>
            </div >
        );
    }
}

export default ShippingCostReport;
